module.exports = __webpack_public_path__ + "22ef06d29fa99ede3f59e7124398ae17.jpg";